/* ============================================================
   Sant & Abel — Unified Bundle Builder
   assets/bundle-builder.js

   Discount codes applied silently at checkout:
   - 2-item bundles: [bundle-key]-10  e.g. mens-sleep-10
   - 3-item bundles: [bundle-key]-15  e.g. mens-sleep-15
   - 1-item: no discount code applied
   ============================================================ */

(function () {
  'use strict';

  // ── Bundle configuration ──────────────────────────────────
  const BUNDLE_CONFIG = {
    'mens-boxer-shorts':   { slots: ['mens-boxer-shorts'],   tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'mens-sleep-shorts':   { slots: ['mens-sleep-shorts'],   tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'mens-pj-pants':       { slots: ['mens-pj-pants'],       tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-long-sets':    { slots: ['womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-pj-pants','womens-robes','womens-nighties','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-short-sets':   { slots: ['womens-short-sets','womens-long-sets','womens-boxer-shorts','womens-pj-pants','womens-robes','womens-nighties','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-boxer-shorts': { slots: ['womens-boxer-shorts','womens-long-sets','womens-short-sets','womens-pj-pants','womens-robes','womens-nighties','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-pj-pants':     { slots: ['womens-pj-pants','womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-robes','womens-nighties','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-robes':        { slots: ['womens-robes','womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-pj-pants','womens-nighties','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-nighties':     { slots: ['womens-nighties','womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-pj-pants','womens-robes','womens-night-shirts','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-night-shirts': { slots: ['womens-night-shirts','womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-pj-pants','womens-robes','womens-nighties','womens-tank-sets'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'womens-tank-sets':    { slots: ['womens-tank-sets','womens-long-sets','womens-short-sets','womens-boxer-shorts','womens-pj-pants','womens-robes','womens-nighties','womens-night-shirts'], tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'swim':            { slots: ['swim'],              tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'kids-long-sets':      { slots: ['kids-long-sets','kids-short-sets'],  tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
    'kids-short-sets':     { slots: ['kids-short-sets','kids-long-sets'],  tiers: [{qty:2,discount:0.10},{qty:3,discount:0.15}] },
  };

  // ── Discount code map ─────────────────────────────────────
  const DISCOUNT_CODES = {
    'mens-boxer-shorts':   { 2: 'MENS-BOXER-BUNDLE-10',  3: 'MENS-BOXER-BUNDLE-15'  },
    'mens-sleep-shorts':   { 2: 'MENS-SLEEP-BUNDLE-10',  3: 'MENS-SLEEP-BUNDLE-15'  },
    'mens-pj-pants':       { 2: 'MENS-PANTS-BUNDLE-10',  3: 'MENS-PANTS-BUNDLE-15'  },
    'womens-long-sets':    { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-short-sets':   { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-boxer-shorts': { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-pj-pants':     { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-robes':        { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-nighties':     { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-night-shirts': { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'womens-tank-sets':    { 2: 'WOMENS-BUNDLE-10',      3: 'WOMENS-BUNDLE-15'      },
    'swim':            { 2: 'SWIM-BUNDLE-10',         3: 'SWIM-BUNDLE-15'         },
    'kids-long-sets':      { 2: 'KIDS-BUNDLE-10',        3: 'KIDS-BUNDLE-15'        },
    'kids-short-sets':     { 2: 'KIDS-BUNDLE-10',        3: 'KIDS-BUNDLE-15'        },
  };

  function getDiscountCode() {
    return (DISCOUNT_CODES[BUNDLE_KEY] || {})[selectedQty] || null;
  }

  const GROUP_LABELS = {
    'mens-boxer-shorts':   "Men's Boxer Shorts",
    'mens-sleep-shorts':   "Men's Sleep Shorts",
    'mens-pj-pants':       "Men's PJ Pants",
    'womens-long-sets':    "Women's Long PJ Sets",
    'womens-short-sets':   "Women's Short PJ Sets",
    'womens-boxer-shorts': "Women's Boxer Shorts",
    'womens-pj-pants':     "Women's PJ Pants",
    'womens-robes':        "Women's Robes",
    'womens-nighties':     "Women's Nighties",
    'womens-night-shirts': "Women's Night Shirts",
    'womens-tank-sets':    "Women's Tank Sets",
    'swim':            "Swim",
    'kids-long-sets':      "Kids Long PJ Sets",
    'kids-short-sets':     "Kids Short PJ Sets",
  };

  // ── Read page context ─────────────────────────────────────
  const wrap        = document.querySelector('.bb-wrap');
  const root        = document.getElementById('bb-root');
  if (!wrap || !root) return;

  const PRODUCTS    = window.__BundleProducts__ || {};
  const BUNDLE_KEY  = wrap.dataset.bundleKey;
  const PAGE_HANDLE = wrap.dataset.pageHandle;
  const PAGE_TITLE  = wrap.dataset.pageTitle;
  const PAGE_IMAGE  = wrap.dataset.pageImage;
  const PAGE_PRICE  = parseFloat(wrap.dataset.pagePrice) || 0;
  const PAGE_SIZE   = wrap.dataset.selectedSize || '';
  const DISC_2      = parseInt(wrap.dataset.discount2 || 10, 10) / 100;
  const DISC_3      = parseInt(wrap.dataset.discount3 || 15, 10) / 100;

  const config = BUNDLE_CONFIG[BUNDLE_KEY];
  if (!config) return;

  config.tiers = config.tiers.map(t => {
    if (t.qty === 2) return { ...t, discount: DISC_2 };
    if (t.qty === 3) return { ...t, discount: DISC_3 };
    return t;
  });

  // Search all slots for the page product — done after a tick to ensure
  // window.__BundleProducts__ is fully populated by the inline script
  function findPageProduct() {
    for (const slot of config.slots) {
      const group = (window.__BundleProducts__ || {})[slot] || [];
      const found = group.find(p => p.handle === PAGE_HANDLE);
      if (found) return found;
    }
    return { handle: PAGE_HANDLE, title: PAGE_TITLE, image: PAGE_IMAGE, price: PAGE_PRICE, sizes: [], available_sizes: [] };
  }

  let PAGE_PRODUCT = findPageProduct();

  // ── State ─────────────────────────────────────────────────
  let selectedQty = config.tiers.find(t => t.discount > 0)?.qty || 2;
  let selections  = [
    { product: PAGE_PRODUCT, size: PAGE_SIZE, group: BUNDLE_KEY },
    { product: null, size: '', group: config.slots[0] },
    { product: null, size: '', group: config.slots[0] },
    { product: null, size: '', group: config.slots[0] },
    { product: null, size: '', group: config.slots[0] },
  ];

  let activeSlot      = null;
  let pendingProduct  = null;
  let pendingSize     = null;
  let sizeOnlyMode    = false;

  // ── Helpers ───────────────────────────────────────────────
  function fmt(price) { return '$' + Math.round(price); }
  function fmtExact(price) { return '$' + price.toFixed(2); }
  function discounted(price, discount) { return Math.round(price * (1 - discount)); }
  function currentDiscount() { return config.tiers.find(t => t.qty === selectedQty)?.discount || 0; }
  function subLine(price, size) {
    const dp = discounted(price, currentDiscount());
    return size ? `${fmt(dp)} · Size: ${size}` : fmt(dp);
  }
  function isComplete() {
    return selections.slice(0, selectedQty).every(s => s.product && s.size);
  }

  // ── SVG helpers ───────────────────────────────────────────
  function shirtSVG() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('style', 'width:20px;height:20px;stroke:#aaa;fill:none');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', 'M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.57a1 1 0 00.99.86H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.86l.58-3.57a2 2 0 00-1.34-2.23z');
    svg.appendChild(p);
    return svg;
  }

  function makeThumb(product, className) {
    const div = document.createElement('div');
    div.className = className || 'bb-thumb';
    if (product && product.image) {
      const img = document.createElement('img');
      img.src     = product.image;
      img.alt     = product.title || '';
      img.loading = 'lazy';
      div.appendChild(img);
    } else {
      div.appendChild(shirtSVG());
    }
    return div;
  }

  // ── Modal elements ────────────────────────────────────────
  const overlay    = document.getElementById('bb-modal-overlay');
  const modalTitle = document.getElementById('bb-modal-title');
  const modalList  = document.getElementById('bb-modal-list');
  const sizeView   = document.getElementById('bb-size-view');
  const sizeGrid   = document.getElementById('bb-size-grid');
  const svProduct  = document.getElementById('bb-size-view-product');
  const confirmBtn = document.getElementById('bb-confirm-btn');
  const backBtn    = document.getElementById('bb-back-btn');

  document.getElementById('bb-modal-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    resetModal();
  }

  function resetModal() {
    modalList.style.display = '';
    sizeView.classList.remove('is-open');
    pendingProduct = null;
    pendingSize    = null;
  }

  // ── Step 1a: Category picker (multi-category bundles only) ─
  // ── Grouped category structure for women's bundles ────────
  const GROUPED_CATEGORIES = {
    'womens-long-sets':    [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-short-sets':   [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-boxer-shorts': [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-pj-pants':     [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-robes':        [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-nighties':     [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-night-shirts': [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
    'womens-tank-sets':    [{heading:'PJ Sets',keys:['womens-long-sets','womens-short-sets','womens-tank-sets']},{heading:'One Pieces',keys:['womens-nighties','womens-night-shirts']},{heading:'PJ Bottoms',keys:['womens-boxer-shorts','womens-pj-pants']},{heading:'Loungewear',keys:['womens-robes']}],
  };

  function openCategoryList() {
    modalTitle.textContent = 'Select a category';
    modalList.style.display = '';
    sizeView.classList.remove('is-open');
    modalList.innerHTML = '';

    const listWrap = document.createElement('div');
    listWrap.className = 'bb-category-list';

    const grouped = GROUPED_CATEGORIES[BUNDLE_KEY];

    if (grouped) {
      // Grouped layout with headings
      grouped.forEach(({ heading, keys }) => {
        const groupEl = document.createElement('div');
        groupEl.className = 'bb-category-group';

        const headingEl = document.createElement('div');
        headingEl.className = 'bb-category-group-label';
        headingEl.textContent = heading;
        groupEl.appendChild(headingEl);

        keys.forEach(groupKey => {
          const groupProducts = PRODUCTS[groupKey] || [];
          if (!groupProducts.length) return;
          const btn = document.createElement('button');
          btn.className = 'bb-category-btn';
          btn.innerHTML = `<span>${GROUP_LABELS[groupKey] || groupKey}</span><span class="bb-category-arrow">&#8250;</span>`;
          btn.addEventListener('click', () => openProductList(groupKey));
          groupEl.appendChild(btn);
        });

        listWrap.appendChild(groupEl);
      });
    } else {
      // Simple list for non-grouped bundles
      config.slots.forEach(groupKey => {
        const groupProducts = PRODUCTS[groupKey] || [];
        if (!groupProducts.length) return;
        const btn = document.createElement('button');
        btn.className = 'bb-category-btn';
        btn.innerHTML = `<span>${GROUP_LABELS[groupKey] || groupKey}</span><span class="bb-category-arrow">&#8250;</span>`;
        btn.addEventListener('click', () => openProductList(groupKey));
        listWrap.appendChild(btn);
      });
    }

    modalList.appendChild(listWrap);
  }

  // ── Step 1b: Product list (filtered to one category) ───────
  function openProductList(groupKey) {
    const products = PRODUCTS[groupKey] || [];
    const disc     = currentDiscount();
    const showBack = config.slots.length > 1;

    modalTitle.textContent = GROUP_LABELS[groupKey] || 'Select an item';
    modalList.style.display = '';
    sizeView.classList.remove('is-open');
    modalList.innerHTML = '';

    // Back to categories button if multi-category
    if (showBack) {
      const backRow = document.createElement('div');
      backRow.className = 'bb-list-back-row';
      backRow.innerHTML = '&#8592; All categories';
      backRow.addEventListener('click', openCategoryList);
      modalList.appendChild(backRow);
    }

    products.forEach(p => appendModalRow(p, groupKey, disc));
  }

  function appendModalRow(p, groupKey, disc) {
    const dp  = discounted(p.price, disc);
    const row = document.createElement('div');
    row.className = 'bb-modal-row';
    row.style.cursor = 'pointer';

    const th   = makeThumb(p, 'bb-modal-thumb');
    const info = document.createElement('div');
    info.innerHTML = `<div class="bb-modal-item-name">${p.title}</div>
      <div class="bb-modal-item-price">${fmt(dp)}<span class="bb-orig">${fmt(p.price)}</span></div>`;

    const btn = document.createElement('button');
    btn.className   = 'bb-select-btn';
    btn.textContent = 'Select';

    function selectProduct(e) {
      e.stopPropagation();
      selections[activeSlot].group = groupKey;
      showSizeStep(p);
    }

    btn.addEventListener('click', selectProduct);
    row.addEventListener('click', selectProduct);

    row.appendChild(th);
    row.appendChild(info);
    row.appendChild(btn);
    modalList.appendChild(row);
  }

  function showSizeStep(product) {
    pendingProduct = product;
    pendingSize    = null;
    modalTitle.textContent  = 'Select a size';
    modalList.style.display = 'none';
    sizeView.classList.add('is-open');
    sizeView.style.flexDirection = 'column';
    sizeView.innerHTML = '';


    const disc = currentDiscount();
    const dp   = discounted(product.price, disc);

    // Top row — image + content side by side
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;flex:1;';

    // Left — tall image panel
    const imgPanel = document.createElement('div');
    imgPanel.className = 'bb-size-view-img';
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      imgPanel.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'bb-size-view-img-placeholder';
      placeholder.appendChild(shirtSVG());
      imgPanel.appendChild(placeholder);
    }

    // Right — content panel
    const content = document.createElement('div');
    content.className = 'bb-size-view-content';

    // Product name + price
    const productInfo = document.createElement('div');
    productInfo.className = 'bb-size-view-product';
    productInfo.innerHTML = `
      <div class="bb-size-view-name">${product.title}</div>
      <div class="bb-size-view-price">${fmt(dp)}<span class="bb-orig">${fmt(product.price)}</span></div>`;

    // Size grid
    const sizeSection = document.createElement('div');
    const sizeLbl = document.createElement('div');
    sizeLbl.className = 'bb-size-view-label';
    sizeLbl.textContent = 'Select a size';

    const newGrid = document.createElement('div');
    newGrid.className = 'bb-size-grid';
    newGrid.id = 'bb-size-grid';

    const allSizes   = product.sizes || [];
    const availSizes = product.available_sizes || [];

    allSizes.forEach(sz => {
      const available = availSizes.includes(sz);
      const chip = document.createElement('div');
      chip.className = 'bb-size-chip' + (!available ? ' is-unavailable' : '');
      chip.textContent = sz;
      chip.addEventListener('click', () => {
        if (!available) return;
        pendingSize = sz;
        newGrid.querySelectorAll('.bb-size-chip').forEach(c => c.classList.remove('is-selected'));
        chip.classList.add('is-selected');
        confirmBtn.disabled = false;
      });
      newGrid.appendChild(chip);
    });

    sizeSection.appendChild(sizeLbl);
    sizeSection.appendChild(newGrid);
    content.appendChild(productInfo);
    content.appendChild(sizeSection);

    row.appendChild(imgPanel);
    row.appendChild(content);
    sizeView.appendChild(row);

    // Footer — full width with back + confirm buttons
    const footer = document.createElement('div');
    footer.style.cssText = 'padding:0.85rem 1.5rem;display:flex;align-items:center;gap:10px;';

    if (!sizeOnlyMode) {
      backBtn.style.display = '';
      footer.appendChild(backBtn);
    } else {
      backBtn.style.display = 'none';
    }

    confirmBtn.disabled = true;
    footer.appendChild(confirmBtn);
    sizeView.appendChild(footer);
  }

  backBtn.addEventListener('click', () => {
    sizeOnlyMode = false;
    // Go back to category list if multi-category, otherwise product list
    if (config.slots.length > 1) {
      openCategoryList();
    } else {
      openProductList(config.slots[0]);
    }
  });

  confirmBtn.addEventListener('click', () => {
    if (!pendingProduct || !pendingSize) return;
    selections[activeSlot].product    = pendingProduct;
    selections[activeSlot].size       = pendingSize;
    sizeOnlyMode = false;
    closeModal();
    buildItems(selectedQty);
  });

  function openModal(slotIndex) {
    activeSlot   = slotIndex;
    sizeOnlyMode = false;
    // Show category picker first for multi-category bundles, else go straight to products
    if (config.slots.length > 1) {
      openCategoryList();
    } else {
      openProductList(config.slots[0]);
    }
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function openSizeOnlyModal(slotIndex) {
    activeSlot   = slotIndex;
    sizeOnlyMode = true;
    modalList.innerHTML = '';
    // Re-find page product at click time to ensure sizes are populated
    const freshPageProduct = findPageProduct();
    showSizeStep(freshPageProduct);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  // ── Complete bar ──────────────────────────────────────────
  function renderCompleteBar(body) {
    const ex = body.querySelector('.bb-complete-bar');
    if (ex) ex.remove();
    if (!isComplete()) return;

    const disc     = currentDiscount();
    const total    = selections.slice(0, selectedQty).reduce((s, x) => s + discounted(x.product.price, disc), 0);
    const original = selections.slice(0, selectedQty).reduce((s, x) => s + x.product.price, 0);
    const saved    = original - total;

    const bar = document.createElement('div');
    bar.className = 'bb-complete-bar';

    // Row 1 — price, strikethrough, you save all on one line
    const prices = document.createElement('div');
    prices.className = 'bb-complete-bar-prices';

    const now = document.createElement('span');
    now.className   = 'bb-price-now';
    now.textContent = fmt(total);
    prices.appendChild(now);

    if (disc > 0) {
      const was = document.createElement('span');
      was.className   = 'bb-price-was';
      was.textContent = fmt(original);
      prices.appendChild(was);

      const saving = document.createElement('span');
      saving.className   = 'bb-price-saving';
      saving.textContent = `· You save ${fmtExact(saved)}`;
      prices.appendChild(saving);
    }

    // Row 2 — full width button
    const btn = document.createElement('button');
    btn.className   = 'bb-add-cart-btn';
    btn.textContent = 'Add bundle to cart';
    btn.addEventListener('click', handleAddToCart);

    bar.appendChild(prices);
    bar.appendChild(btn);
    body.appendChild(bar);
  }

  async function addTimesactPreorderLabels(items) {
    try {
      const ids = [...new Set(items.map(i => i._productId))].join(',');
      const res = await fetch(`/apps/timesact/products?productIds=${ids}`);
      const products = res.ok ? ((await res.json()).products || {}) : {};
      let settings = (window.ta && window.ta.settings) || null;
      if (!settings) {
        const sRes = await fetch('/apps/timesact/shop/settings');
        settings = sRes.ok ? ((await sRes.json()).settings || {}) : {};
      }
      const pd = window.ta && window.ta.currentTimesactProductData;
      const defaultTpl = pd && pd.defaultSettings && pd.defaultSettings.templates && pd.defaultSettings.templates.PO;
      items.forEach(item => {
        const product = products[item._productId];
        const variant = product && product.variants && product.variants[item.id];
        const config = variant && variant.config;
        if (!config || config.status !== 'ACTIVE') return;
        const tpl = settings[config.settingsTemplate] || settings[defaultTpl];
        const label = tpl && tpl.cart && tpl.cart.labelText;
        if (label && label.isEnabled !== false && label.key && label.value) {
          item.properties = Object.assign({}, item.properties, { [label.key]: label.value });
        }
      });
    } catch (e) {}
    items.forEach(item => { delete item._productId; });
  }

  // ── Add to cart with silent discount ──────────────────────
  async function handleAddToCart() {
    const btn = root.querySelector('.bb-add-cart-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
      // Step 1: Resolve variant IDs for each selected item + size
      const variantIds = await Promise.all(
        selections.slice(0, selectedQty).map(async s => {
          const res  = await fetch(`/products/${s.product.handle}.js`);
          const data = await res.json();
          const v    = data.variants.find(v => v.option1 === s.size && v.available === true);
          return v ? { id: v.id, quantity: 1, _productId: data.id } : null;
        })
      );

      const valid = variantIds.filter(Boolean);
      await addTimesactPreorderLabels(valid);
      if (valid.length !== selectedQty) {
        alert('One or more selected sizes is no longer available. Please refresh and try again.');
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        return;
      }

      // Step 2: Add items to cart with bundle attributes
      const disc = currentDiscount();
      await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: valid,
          attributes: {
            bundle_type:     BUNDLE_KEY,
            bundle_discount: `${Math.round(disc * 100)}%`,
            bundle_qty:      selectedQty,
          },
        }),
      });

      // Step 3: Store discount code — only upgrade within same bundle type, never replace different bundles
      const newCode = getDiscountCode();
      if (newCode) {
        const stored = JSON.parse(localStorage.getItem('bb_discount_codes') || '[]');
        const bundlePrefix = newCode.replace(/-\d+$/, '');
        const existingCode = stored.find(c => c.replace(/-\d+$/, '') === bundlePrefix);

        const getTier = c => parseInt(c.match(/-(\d+)$/)?.[1] || '0');
        const newTier = getTier(newCode);
        const existingTier = existingCode ? getTier(existingCode) : 0;

        if (!existingCode) {
          stored.push(newCode);
          localStorage.setItem('bb_discount_codes', JSON.stringify(stored));
        } else if (newTier > existingTier) {
          const filtered = stored.filter(c => c.replace(/-\d+$/, '') !== bundlePrefix);
          filtered.push(newCode);
          localStorage.setItem('bb_discount_codes', JSON.stringify(filtered));
        }
      }

      // Step 4: Apply all stored codes sequentially via /discount/ endpoint
      const allStored = JSON.parse(localStorage.getItem('bb_discount_codes') || '[]');
      for (const code of allStored) {
        await fetch(`/discount/${code}`, {
          method: 'GET',
          credentials: 'same-origin',
        });
      }

      // Step 5: Go to cart
      window.location.href = '/cart';

    } catch (err) {
      console.error('[BundleBuilder] Add to cart error:', err);
      if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
    }
  }



  function buildItems(qty) {
    const body = document.getElementById(`bb-tier-body-${qty}`);
    if (!body) return;
    body.innerHTML = '';

    const displayQty = qty;

    for (let i = 0; i < displayQty; i++) {
      const s = selections[i] || { product: null, size: '', group: config.slots[0] };
      const wrapper = document.createElement('div');
      wrapper.className = 'bb-item-block';

      if (i === 0) {
        const row = document.createElement('div');
        row.className = 'bb-item-row';
        row.appendChild(makeThumb(PAGE_PRODUCT));

        const info = document.createElement('div');
        info.className = 'bb-item-info';
        info.innerHTML = `<div class="bb-item-name">${PAGE_PRODUCT.title}</div>
          <div class="bb-item-sub">${subLine(PAGE_PRODUCT.price, s.size)}</div>`;

        const right = document.createElement('div');
        right.className = 'bb-item-right';
        const chg = document.createElement('button');
        chg.className   = 'bb-change-btn';
        chg.textContent = s.size ? 'Change' : 'Pick size';
        chg.type        = 'button';
        chg.addEventListener('click', () => openSizeOnlyModal(0));
        right.appendChild(chg);

        row.appendChild(info);
        row.appendChild(right);
        wrapper.appendChild(row);

        if (!s.size) {
          const hint = document.createElement('div');
          hint.className   = 'bb-size-hint';
          hint.textContent = 'Select a size to continue';
          wrapper.appendChild(hint);
        }

      } else if (s.product) {
        const row = document.createElement('div');
        row.className = 'bb-item-row';
        row.appendChild(makeThumb(s.product));

        const info = document.createElement('div');
        info.className = 'bb-item-info';
        info.innerHTML = `<div class="bb-item-name">${s.product.title}</div>
          <div class="bb-item-sub">${subLine(s.product.price, s.size)}</div>`;

        const right = document.createElement('div');
        right.className = 'bb-item-right';
        const chg = document.createElement('button');
        chg.className   = 'bb-change-btn';
        chg.textContent = 'Change';
        chg.addEventListener('click', () => openModal(i));
        right.appendChild(chg);

        row.appendChild(info);
        row.appendChild(right);
        wrapper.appendChild(row);

      } else {
        const slot = document.createElement('div');
        slot.className = 'bb-add-slot';
        slot.addEventListener('click', () => openModal(i));
        const icon = document.createElement('div');
        icon.className   = 'bb-add-icon';
        icon.textContent = '+';
        const lbl = document.createElement('span');
        lbl.className   = 'bb-add-label';
        lbl.textContent = 'Select item';
        slot.appendChild(icon);
        slot.appendChild(lbl);
        wrapper.appendChild(slot);
      }

      body.appendChild(wrapper);
    }

    renderCompleteBar(body);
  }

  // ── Build tier cards ──────────────────────────────────────
  function buildTiers() {
    root.innerHTML = '';

    const bar = document.createElement('div');
    bar.className   = 'bb-discount-bar';
    bar.textContent = 'Bundle to save';
    root.appendChild(bar);

    const group = document.createElement('div');
    group.className = 'bb-tier-group';

    config.tiers.forEach(tier => {
      const isSelected = tier.qty === selectedQty;
      const card       = document.createElement('div');
      card.className   = 'bb-tier-card' + (isSelected ? ' is-selected' : '');

      const header = document.createElement('div');
      header.className = 'bb-tier-header';

      const radio = document.createElement('div');
      radio.className = 'bb-radio';
      radio.innerHTML = '<div class="bb-radio-inner"></div>';

      const label = document.createElement('span');
      label.className   = 'bb-tier-label';
      label.textContent = `${tier.qty} item${tier.qty > 1 ? 's' : ''}`;

      header.appendChild(radio);
      header.appendChild(label);

      if (tier.discount > 0) {
        const pill = document.createElement('span');
        pill.className   = 'bb-savings-pill';
        pill.textContent = `${Math.round(tier.discount * 100)}% off`;
        header.appendChild(pill);
      }

      header.addEventListener('click', () => {
        selectedQty = tier.qty;
        buildTiers();
      });

      card.appendChild(header);

      if (isSelected) {
        const body    = document.createElement('div');
        body.className = 'bb-tier-body';
        body.id        = `bb-tier-body-${tier.qty}`;
        card.appendChild(body);
      }

      group.appendChild(card);
    });

    root.appendChild(group);
    buildItems(selectedQty);
  }

  // ── Sync size from page variant picker ───────────────────
  // Listens for the customer clicking a size on the Impulse theme
  // size picker and syncs it into bundle slot 1.
  document.addEventListener('click', function(e) {
    const label = e.target.closest('label.variant__button-label');
    if (!label) return;

    const forAttr = label.getAttribute('for') || '';
    // Only respond to size option labels for this product
    if (!forAttr.toLowerCase().includes('option-size')) return;

    const size = label.textContent.trim();
    if (!size) return;

    selections[0].size = size;
    buildTiers();
  });

  // ── Init ──────────────────────────────────────────────────
  buildTiers();

})();